























import Vue from 'vue'
import { mapState } from 'vuex'

import { SingleActions, Actions } from '@/shared/Actions'
import { IRoomForm } from '@/models/IRoom'

import RoomForm from '@/components/RoomForm.vue'
import RoomSimpleCard from '@/components/RoomSimpleCard.vue'
import Spinner from '@/components/Spinner.vue'

export default Vue.extend({
  name: 'RoomsManagement',
  components: { RoomForm, RoomSimpleCard, Spinner },
  data: () => ({
    roomToEdit: null as string | null
  }),
  computed: {
    ...mapState({
      rooms: 'rooms'
    })
  },
  mounted() {
    this.$store.dispatch(SingleActions.FETCH_ALL_ROOMS)
  },
  methods: {
    editRoom(id: string) {
      this.roomToEdit = id
    },
    async createNewRoom(room: IRoomForm) {
      this.$store.dispatch(SingleActions.CREATE_ROOM, room)
    },
    async updateRoom(room: IRoomForm) {
      await this.$store.dispatch(Actions.UPDATE_ROOM, { id: this.roomToEdit, payload: room })
      this.roomToEdit = null
    },
    async hideRoom(id: string, hide: boolean) {
      /* eslint-disable prettier/prettier */
      const message = hide
          ? `Jesteś pewnien, że schować ten ${this.$t('pokoj_s')}? \n Schowanych ${this.$t('pokoi_s')} nie widać na liście zapisowej.`
          : `Jesteś pewnien, że uwidocznić ten ${this.$t('pokoj_s')}? \n Będzie on widoczny na liście zapisowej dla wszystkich uczestników wydarzenia.`
      this.$confirm(
          message,
          'Potwierdzenie',
          {
            confirmButtonText: 'Tak',
            cancelButtonText: 'Nie',
            type: 'error'
          }
      ).then(() => {
        this.$store.dispatch(Actions.HIDE_ROOM, {id, hide})
      })
    },
    async removeRoom(id: string) {
      this.$confirm(`Jesteś pewnien, że chcesz usunąć ten ${this.$t('pokoj_s')}`, 'Potwierdzenie', {
        confirmButtonText: 'Tak',
        cancelButtonText: 'Nie',
        type: 'error'
      }).then(() => {
        this.$store.dispatch(Actions.DELETE_ROOM, id)
      })
    }
  }
})
